<template>
    <div v-if="data">
        <b-dropdown
            text="Block Primary"
            block
            variant="white"
            class="unidades-content"
            menu-class="w-100"
            size="lg"
            no-caret
            @toggle="toggle()"
            @hidden="close()"
        >
            <template #button-content>
                <div class="collapse-toggle" v-b-toggle="'collapse' + _uid"></div>
                <b-row style="flex-wrap: nowrap" align-v="center" v-b-toggle="'collapse' + _uid">
                    <b-col cols="10" class="unidades-header">
                        <i class="icon-header" :class="headerIcon"></i>
                        <span class="title">{{ placeholder }}</span>
                    </b-col>
                    <b-col cols="2">
                        <i class="icon-gray" :class="iconToggle ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
                    </b-col>
                </b-row>
            </template>
        </b-dropdown>
        <b-collapse :id="'collapse' + _uid">
            <b-form :class="!selectAll && 'pt-4'" class="unidades-form">
                <b-row v-if="selectAll" class="checkbox-all">
                    <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate">
                        <span class="ml-3">{{ $t('strategy.onepage.advancedOptions.units.selectAll') }}</span>
                    </b-form-checkbox>
                </b-row>
                <b-form-checkbox
                    v-for="(item, id) in list"
                    :key="`${item + id}`"
                    v-model="item.value"
                    class="item"
                    @change="updateCheck(item)"
                >
                    <div class="dropdown">
                        <b-row>
                            <i v-if="item.icon" class="icon-item" :class="item.icon"></i>
                            <svg
                                v-else
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="#6e6e6e"
                                class="bi bi-people icon-item"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                />
                            </svg>
                            <span>{{ item.name }}</span>
                        </b-row>
                    </div>
                </b-form-checkbox>
            </b-form>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'DropdownCheckbox',
    props: ['selectAll', 'data', 'title', 'placeholder', 'headerIcon'],
    data() {
        return {
            iconToggle: false,
            list: {
                type: Array,
            },
            allSelected: false,
            indeterminate: true,
        }
    },
    created() {
        this.list = this.data
    },
    updated() {
        this.list = this.data
    },
    watch: {
        iconToggle() {
            return this.iconToggle
        },
        allSelected(newValue) {
            this.list = this.list.map((item) => {
                if (newValue) {
                    return { ...item, value: true }
                } else {
                    return { ...item, value: false }
                }
            })
            this.indeterminate = false
            this.$emit('listUpdateAll', [this.list, newValue])
        },
    },
    methods: {
        toggle() {
            this.iconToggle = !this.iconToggle
        },
        close() {
            this.iconToggle = false
            this.$emit('closeModal', { data: this.list })
        },
        updateCheck(item) {
            this.$emit('listUpdate', [this.list, item])
            if (item.value) {
                return (this.indeterminate = true)
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.fas, .far
    font-size: 1rem
    color: #6e6e6e
    opacity: .8
.unidades-content
    width: 100%
    border: 1px solid #e4e5e6
    border-radius: 5px
    .collapse-toggle
        top: 0
        left: 0
        right: 0
        bottom: 0
        position: absolute
    ul.dropdown-menu
        display: none !important
    .icon-gray
        font-size: 1.2rem
        color: #6e6e6e
        text-align: end
    .unidades-header
        text-align: start
        .icon-header
            color: #009ada
            margin-right: 2rem
        .title
            font-size: 1rem
            color: #6e6e6e
            font-weight: bold

.unidades-form
    min-width: 350px
    width: 100%
    display: flex
    flex-direction: column
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.25)
    border-radius: 10px
    padding: 0 1rem
    margin-top: .2rem
    .checkbox-all
        padding: .6rem 1rem
    .item
        .dropdown
            padding-bottom: 2rem
            cursor: pointer
            .icon-item
                margin: 0.2rem 1rem 0 2rem
                width: irem
                text-align: start
</style>
